import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const BlogPostForm = ({ formData, onFormChange, onGenerate, isGenerating }) => {
  const categoryOptions = [
    { value: 'book-review', label: 'Book Review' },
    { value: 'author-interview', label: 'Author Interview' },
    { value: 'industry-news', label: 'Industry News' },
    { value: 'writing-tips', label: 'Writing Tips' },
    { value: 'book-launch', label: 'Book Launch' },
    { value: 'literary-analysis', label: 'Literary Analysis' },
    { value: 'publishing-insights', label: 'Publishing Insights' }
  ];

  const lengthOptions = [
    { value: 'short', label: 'Short (300-500 words)' },
    { value: 'medium', label: 'Medium (500-800 words)' },
    { value: 'long', label: 'Long (800-1200 words)' }
  ];

  const toneOptions = [
    { value: 'professional', label: 'Professional' },
    { value: 'conversational', label: 'Conversational' },
    { value: 'academic', label: 'Academic' },
    { value: 'casual', label: 'Casual' },
    { value: 'authoritative', label: 'Authoritative' }
  ];

  const handleInputChange = (field, value) => {
    onFormChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-6">
      <Input
        label="Blog Post Title"
        type="text"
        placeholder="Enter your blog post title or topic"
        value={formData?.title || ''}
        onChange={(e) => handleInputChange('title', e?.target?.value)}
        required
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Category"
          options={categoryOptions}
          value={formData?.category || ''}
          onChange={(value) => handleInputChange('category', value)}
          placeholder="Select category"
          required
        />
        <Select
          label="Post Length"
          options={lengthOptions}
          value={formData?.length || ''}
          onChange={(value) => handleInputChange('length', value)}
          placeholder="Select length"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Content Outline
        </label>
        <textarea
          className="w-full h-32 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
          placeholder="Provide key points or outline for your blog post"
          value={formData?.outline || ''}
          onChange={(e) => handleInputChange('outline', e?.target?.value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Tone"
          options={toneOptions}
          value={formData?.tone || ''}
          onChange={(value) => handleInputChange('tone', value)}
          placeholder="Select tone"
          required
        />
        <Input
          label="Target Keywords"
          type="text"
          placeholder="SEO keywords (comma separated)"
          value={formData?.keywords || ''}
          onChange={(e) => handleInputChange('keywords', e?.target?.value)}
        />
      </div>
      <div className="space-y-3">
        <Checkbox
          label="SEO Optimization"
          description="Include meta description and optimize for search engines"
          checked={formData?.seoOptimized || false}
          onChange={(e) => handleInputChange('seoOptimized', e?.target?.checked)}
        />
        <Checkbox
          label="Include Images Suggestions"
          description="Generate suggestions for relevant images"
          checked={formData?.includeImages || false}
          onChange={(e) => handleInputChange('includeImages', e?.target?.checked)}
        />
        <Checkbox
          label="Add Call-to-Action"
          description="Include engaging call-to-action at the end"
          checked={formData?.includeCTA || false}
          onChange={(e) => handleInputChange('includeCTA', e?.target?.checked)}
        />
      </div>
      <Button
        onClick={onGenerate}
        loading={isGenerating}
        iconName="Edit3"
        iconPosition="left"
        className="w-full"
        disabled={!formData?.title || !formData?.category || !formData?.length}
      >
        {isGenerating ? 'Generating Blog Post...' : 'Generate Blog Post'}
      </Button>
    </div>
  );
};

export default BlogPostForm;